import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getCompanyAnalyticDetailApi,
  getCompanyOauthDetailApi,
  getCompanyRazorpayDetailApi,
  getCompanyShiprocketDetailApi,
  postCompanyAnalyticDetailApi,
  postCompanyOauthDetailApi,
  postCompanyRazorpayDetailApi,
  postCompanyShiprocketDetailApi,
  updateCompanyAnalyticDetailApi,
  updateCompanyOauthDetailApi,
  updateCompanyRazorpayDetailApi,
  updateCompanyShiprocketDetailApi,
} from "../../api/common/CompanyIntegrationApi";

const initialState = {
  shiprocketDetail: null,
  razorpayDetail: null,
  oauthDetail: null,
  analyticDetail: null,
  loading: false,
  saving: false,
  error: null,
};

const getErrorPayload = (err) => ({
  errorMessage: err?.response?.data?.message || err?.message || "Something went wrong",
});

export const getCompanyShiprocketDetail = createAsyncThunk(
  "companyIntegration/getCompanyShiprocketDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getCompanyShiprocketDetailApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue(getErrorPayload(err));
    }
  },
);

export const postCompanyShiprocketDetail = createAsyncThunk(
  "companyIntegration/postCompanyShiprocketDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postCompanyShiprocketDetailApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue(getErrorPayload(err));
    }
  },
);

export const updateCompanyShiprocketDetail = createAsyncThunk(
  "companyIntegration/updateCompanyShiprocketDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateCompanyShiprocketDetailApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue(getErrorPayload(err));
    }
  },
);

export const getCompanyRazorpayDetail = createAsyncThunk(
  "companyIntegration/getCompanyRazorpayDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getCompanyRazorpayDetailApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue(getErrorPayload(err));
    }
  },
);

export const postCompanyRazorpayDetail = createAsyncThunk(
  "companyIntegration/postCompanyRazorpayDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postCompanyRazorpayDetailApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue(getErrorPayload(err));
    }
  },
);

export const updateCompanyRazorpayDetail = createAsyncThunk(
  "companyIntegration/updateCompanyRazorpayDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateCompanyRazorpayDetailApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue(getErrorPayload(err));
    }
  },
);

export const getCompanyOauthDetail = createAsyncThunk(
  "companyIntegration/getCompanyOauthDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getCompanyOauthDetailApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue(getErrorPayload(err));
    }
  },
);

export const postCompanyOauthDetail = createAsyncThunk(
  "companyIntegration/postCompanyOauthDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postCompanyOauthDetailApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue(getErrorPayload(err));
    }
  },
);

export const updateCompanyOauthDetail = createAsyncThunk(
  "companyIntegration/updateCompanyOauthDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateCompanyOauthDetailApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue(getErrorPayload(err));
    }
  },
);

export const getCompanyAnalyticDetail = createAsyncThunk(
  "companyIntegration/getCompanyAnalyticDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getCompanyAnalyticDetailApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue(getErrorPayload(err));
    }
  },
);

export const postCompanyAnalyticDetail = createAsyncThunk(
  "companyIntegration/postCompanyAnalyticDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postCompanyAnalyticDetailApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue(getErrorPayload(err));
    }
  },
);

export const updateCompanyAnalyticDetail = createAsyncThunk(
  "companyIntegration/updateCompanyAnalyticDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateCompanyAnalyticDetailApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue(getErrorPayload(err));
    }
  },
);

const companyIntegrationSlice = createSlice({
  name: "companyIntegration",
  initialState,
  reducers: {
    clearCompanyIntegrationError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCompanyShiprocketDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCompanyShiprocketDetail.fulfilled, (state, action) => {
        state.shiprocketDetail = action?.payload?.response;
        state.loading = false;
      })
      .addCase(getCompanyShiprocketDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.errorMessage || null;
      })
      .addCase(postCompanyShiprocketDetail.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(postCompanyShiprocketDetail.fulfilled, (state, action) => {
        state.shiprocketDetail = action?.payload?.response;
        state.saving = false;
      })
      .addCase(postCompanyShiprocketDetail.rejected, (state, action) => {
        state.saving = false;
        state.error = action?.payload?.errorMessage || null;
      })
      .addCase(updateCompanyShiprocketDetail.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(updateCompanyShiprocketDetail.fulfilled, (state, action) => {
        state.shiprocketDetail = action?.payload?.response;
        state.saving = false;
      })
      .addCase(updateCompanyShiprocketDetail.rejected, (state, action) => {
        state.saving = false;
        state.error = action?.payload?.errorMessage || null;
      })
      .addCase(getCompanyRazorpayDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCompanyRazorpayDetail.fulfilled, (state, action) => {
        state.razorpayDetail = action?.payload?.response;
        state.loading = false;
      })
      .addCase(getCompanyRazorpayDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.errorMessage || null;
      })
      .addCase(postCompanyRazorpayDetail.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(postCompanyRazorpayDetail.fulfilled, (state, action) => {
        state.razorpayDetail = action?.payload?.response;
        state.saving = false;
      })
      .addCase(postCompanyRazorpayDetail.rejected, (state, action) => {
        state.saving = false;
        state.error = action?.payload?.errorMessage || null;
      })
      .addCase(updateCompanyRazorpayDetail.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(updateCompanyRazorpayDetail.fulfilled, (state, action) => {
        state.razorpayDetail = action?.payload?.response;
        state.saving = false;
      })
      .addCase(updateCompanyRazorpayDetail.rejected, (state, action) => {
        state.saving = false;
        state.error = action?.payload?.errorMessage || null;
      })
      .addCase(getCompanyOauthDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCompanyOauthDetail.fulfilled, (state, action) => {
        state.oauthDetail = action?.payload?.response;
        state.loading = false;
      })
      .addCase(getCompanyOauthDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.errorMessage || null;
      })
      .addCase(postCompanyOauthDetail.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(postCompanyOauthDetail.fulfilled, (state, action) => {
        state.oauthDetail = action?.payload?.response;
        state.saving = false;
      })
      .addCase(postCompanyOauthDetail.rejected, (state, action) => {
        state.saving = false;
        state.error = action?.payload?.errorMessage || null;
      })
      .addCase(updateCompanyOauthDetail.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(updateCompanyOauthDetail.fulfilled, (state, action) => {
        state.oauthDetail = action?.payload?.response;
        state.saving = false;
      })
      .addCase(updateCompanyOauthDetail.rejected, (state, action) => {
        state.saving = false;
        state.error = action?.payload?.errorMessage || null;
      })
      .addCase(getCompanyAnalyticDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCompanyAnalyticDetail.fulfilled, (state, action) => {
        state.analyticDetail = action?.payload?.response;
        state.loading = false;
      })
      .addCase(getCompanyAnalyticDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.errorMessage || null;
      })
      .addCase(postCompanyAnalyticDetail.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(postCompanyAnalyticDetail.fulfilled, (state, action) => {
        state.analyticDetail = action?.payload?.response;
        state.saving = false;
      })
      .addCase(postCompanyAnalyticDetail.rejected, (state, action) => {
        state.saving = false;
        state.error = action?.payload?.errorMessage || null;
      })
      .addCase(updateCompanyAnalyticDetail.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(updateCompanyAnalyticDetail.fulfilled, (state, action) => {
        state.analyticDetail = action?.payload?.response;
        state.saving = false;
      })
      .addCase(updateCompanyAnalyticDetail.rejected, (state, action) => {
        state.saving = false;
        state.error = action?.payload?.errorMessage || null;
      });
  },
});

export const { clearCompanyIntegrationError } = companyIntegrationSlice.actions;
export default companyIntegrationSlice.reducer;
